import * as types from '../actions/metadata/types';

const INITIAL_STATE = {
  activeMenuItemKey: '',
  pageTitle: '',
  pageDescription: '',
};

export default function metadataReducer(state = INITIAL_STATE, action) {

  switch(action.type) {
    case types.METADATA:
      return {
        ...state,
        ...action.payload,
      };

    default: return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/metadataReducer.js